export const initialProjectionState = {
    growthRate: 10,
    discountRate: 9,
    userInitialFCF: null,
};

export function projectionReducer(state, action) {
    switch (action.type) {
        case 'set_growth':
            return { ...state, growthRate: action.payload };
        case 'set_discount':
            return { ...state, discountRate: action.payload };
        case 'set_user_initial_fcf':
            return { ...state, userInitialFCF: action.payload };
        case 'reset_user_initial_fcf':
            return { ...state, userInitialFCF: null };
        default:
            return state;
    }
}
